export default __webpack_public_path__ + "static/media/Lightsaber Ki-Adi AOTC - Img - Final2_07.c51de1f1.jpg";